export default __webpack_public_path__ + "static/media/backIcon.c8a355ab.svg";